import React from 'react';
import { ModalBackdrop } from '../modal-backdrop';
import { useCrisisModal } from '../../../contexts/crisis-modal-context';
import { ResourceTile } from '../../resource-tile';
import { CrisisResourceSectionTitle } from '../../crisis-resource-section-title';

// Close icon component
const CloseIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Alert triangle icon for emergency
// TODO: clean up pass move this to a svg folder?
const AlertIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64 18.3 1.55 18.64 1.55 19C1.55 19.36 1.64 19.7 1.82 20C2 20.3 2.25 20.55 2.55 20.73C2.85 20.91 3.19 21 3.55 21H20.45C20.81 21 21.15 20.91 21.45 20.73C21.75 20.55 22 20.3 22.18 20C22.36 19.7 22.45 19.36 22.45 19C22.45 18.64 22.36 18.3 22.18 18L13.71 3.86C13.53 3.56 13.28 3.31 12.98 3.13C12.68 2.95 12.34 2.86 12 2.86C11.66 2.86 11.32 2.95 11.02 3.13C10.72 3.31 10.47 3.56 10.29 3.86Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Heart hand icon for support
const HeartHandIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 5.5C12 4.12 13.12 3 14.5 3C15.88 3 17 4.12 17 5.5C17 6.88 15.88 8 14.5 8H12V5.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.5C12 4.12 10.88 3 9.5 3C8.12 3 7 4.12 7 5.5C7 6.88 8.12 8 9.5 8H12V5.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14H6.39C6.77 14 7.15 14.11 7.47 14.32L10.53 16.18C10.85 16.39 11.23 16.5 11.61 16.5H14C15.1 16.5 16 15.6 16 14.5C16 13.4 15.1 12.5 14 12.5H12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 12.5L19.53 11.32C20.3 10.73 21.37 10.81 22.06 11.5V11.5C22.75 12.19 22.83 13.26 22.24 14.03L18.69 18.65C18.24 19.23 17.57 19.6 16.83 19.68L13.77 20C13.05 20.08 12.33 19.87 11.76 19.43L10.24 18.29C9.55 17.76 9.1 17 9 16.15L8.66 13.39C8.52 12.24 9.31 11.21 10.46 11.06C11.28 10.96 12.06 11.39 12.42 12.11L12.5 12.28"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Phone icon
const PhoneIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.33 14.1V16.6C18.33 17.0359 18.1568 17.4538 17.8492 17.7617C17.5416 18.0695 17.1238 18.243 16.688 18.2437C13.951 18.2437 11.282 17.4797 8.97503 16.0437C6.83503 14.7437 5.04503 12.9537 3.74503 10.8137C2.30169 8.49701 1.53836 5.81701 1.54503 3.07034C1.54503 2.63534 1.71836 2.21867 2.02503 1.91201C2.33169 1.60534 2.74836 1.43201 3.18336 1.43201H5.68336C6.45336 1.42534 7.10836 1.98534 7.21836 2.74701C7.31503 3.41034 7.48003 4.06201 7.71003 4.69034C7.92336 5.27367 7.77336 5.92867 7.32003 6.38701L6.26003 7.44701C7.46503 9.56867 9.20003 11.3037 11.3217 12.5087L12.3817 11.4487C12.84 10.9954 13.495 10.8454 14.0784 11.0587C14.7067 11.2887 15.3584 11.4537 16.0217 11.5504C16.7917 11.6614 17.3534 12.3254 17.3384 13.1004L18.33 14.1Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Message icon
const MessageIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 12.5C17.5 12.942 17.3244 13.366 17.0118 13.6785C16.6993 13.991 16.2754 14.1667 15.8333 14.1667H5.83333L2.5 17.5V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V12.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// External link icon
const ExternalLinkIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 2H14V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.66663 9.33333L14 2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CrisisModalGlobal: React.FC = () => {
  const { isOpen, emergency, crisisResource, closeCrisisModal } = useCrisisModal();

  if (!isOpen) return null;

  const hasCrisisResource = Boolean(crisisResource);

  return (
    <>
      <ModalBackdrop />
      <div
        className={`fixed bottom-0 left-0 right-0 z-40 flex max-h-[90vh] w-full flex-col overflow-hidden rounded-t-[15px] bg-white sm:bottom-auto sm:left-1/2 sm:right-auto sm:top-1/2 sm:max-h-[90vh] sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-[12px] ${
          hasCrisisResource ? 'sm:max-w-[720px]' : 'sm:max-w-[480px]'
        }`}
      >
        <div className="flex min-h-0 flex-1 flex-col p-6">
          {/* Header */}
          <div className="flex shrink-0 items-center justify-between pb-5">
            <div className="flex items-center gap-3">
              <div
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${
                  emergency ? 'bg-red-100' : 'bg-blue-100'
                }`}
              >
                {emergency ? (
                  <AlertIcon className="h-5 w-5 text-red-600" />
                ) : (
                  <HeartHandIcon className="h-5 w-5 text-blue-600" />
                )}
              </div>
              <div>
                <p className="font-albert-sans text-label-gray text-lg font-semibold leading-6">
                  {emergency ? 'Crisis Support' : "We're here to help"}
                </p>
                <p className="font-albert-sans text-placeholder-gray text-sm">
                  {emergency ? 'Immediate help is available' : "You're not alone"}
                </p>
              </div>
            </div>
            <button
              onClick={closeCrisisModal}
              className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-50 transition-colors hover:bg-gray-100"
              aria-label="Close modal"
            >
              <CloseIcon className="text-label-gray h-5 w-5" />
            </button>
          </div>

          {/* Divider */}
          <div className="border-input-border-gray mb-5 shrink-0 border-b" />

          {/* Scrollable content */}
          <div className="min-h-0 flex-1 overflow-y-auto">
            <div
              className={
                hasCrisisResource
                  ? 'flex flex-col gap-4 md:flex-row md:items-start md:gap-6 [@media(max-height:700px)]:flex-col'
                  : 'flex flex-col gap-4'
              }
            >
              <div className="flex min-w-0 flex-1 flex-col gap-4">
                {emergency ? (
                  <>
                    <div className="rounded-lg border border-red-200 bg-red-50 p-4">
                      <p className="font-albert-sans text-sm font-medium leading-5 text-red-800">
                        If you are in immediate danger, please call 911 right away. Your safety is our top priority.
                      </p>
                    </div>

                    <p className="font-albert-sans text-body-gray text-sm">
                      Professional crisis counselors are available 24/7. They're trained to help and want to hear from
                      you.
                    </p>

                    {/* Emergency buttons */}
                    <div className="flex flex-col gap-3">
                      <button
                        onClick={() => window.open('tel:911')}
                        className="font-albert-sans flex w-full items-center justify-center gap-2 rounded-full bg-red-600 px-5 py-3 text-base font-medium text-white transition-colors hover:bg-red-700"
                      >
                        <PhoneIcon className="h-5 w-5" />
                        Call 911 Now
                      </button>

                      <button
                        onClick={() => window.open('tel:988')}
                        className="font-albert-sans border-input-border-gray text-label-gray flex w-full items-center justify-center gap-2 rounded-full border bg-white px-5 py-3 text-base font-medium transition-colors hover:bg-gray-50"
                      >
                        <PhoneIcon className="h-5 w-5" />
                        988 Suicide & Crisis Lifeline
                      </button>

                      <button
                        onClick={() => window.open('sms:741741?body=HOME')}
                        className="font-albert-sans border-input-border-gray text-label-gray flex w-full items-center justify-center gap-2 rounded-full border bg-white px-5 py-3 text-base font-medium transition-colors hover:bg-gray-50"
                      >
                        <MessageIcon className="h-5 w-5" />
                        Text HOME to 741741
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <p className="font-albert-sans text-body-gray text-sm leading-5">
                      It looks like you might be going through a difficult time. Professional crisis counselors are
                      available 24/7 and want to help. Reaching out is a sign of strength.
                    </p>

                    {/* Support buttons */}
                    <div className="flex flex-col gap-3">
                      <button
                        onClick={() => window.open('tel:988')}
                        className="font-albert-sans bg-button-primary hover:bg-button-primary-hover flex w-full items-center justify-center gap-2 rounded-full px-5 py-3 text-base font-medium text-white shadow-sm transition-colors"
                      >
                        <PhoneIcon className="h-5 w-5" />
                        Call 988 Suicide & Crisis Lifeline
                      </button>

                      <button
                        onClick={() => window.open('sms:741741?body=HOME')}
                        className="font-albert-sans border-input-border-gray text-label-gray flex w-full items-center justify-center gap-2 rounded-full border bg-white px-5 py-3 text-base font-medium shadow-sm transition-colors hover:bg-gray-50"
                      >
                        <MessageIcon className="h-5 w-5" />
                        Text HOME to 741741
                      </button>

                      <button
                        onClick={() => window.open('https://988lifeline.org/chat/')}
                        className="font-albert-sans border-input-border-gray text-label-gray flex w-full items-center justify-center gap-2 rounded-full border bg-white px-5 py-3 text-base font-medium shadow-sm transition-colors hover:bg-gray-50"
                      >
                        <ExternalLinkIcon className="h-5 w-5" />
                        Chat with a Counselor Online
                      </button>
                    </div>
                  </>
                )}
              </div>

              {crisisResource ? (
                <div className="md:border-input-border-gray flex w-full shrink-0 flex-col pt-2 md:w-[260px] md:border-l md:pl-6 md:pt-0 [@media(max-height:700px)]:w-full [@media(max-height:700px)]:border-l-0 [@media(max-height:700px)]:pl-0 [@media(max-height:700px)]:pt-2">
                  <CrisisResourceSectionTitle
                    emergency={emergency}
                    imageUrl={crisisResource.image_url || crisisResource.wide_image_url}
                  />
                  <div className="flex justify-center">
                    <ResourceTile resource={crisisResource} centered />
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          {/* Footer */}
          <div className="border-input-border-gray mt-6 shrink-0 border-t pt-4">
            <button
              onClick={closeCrisisModal}
              className="font-albert-sans text-placeholder-gray hover:text-body-gray w-full text-sm font-medium transition-colors"
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
